<template>

    <div class="wrapper">

        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">
            <div class="top" style="height:60px;">


            </div>

            <h4 style="margin-left:10px; font-weight:800;">My Profile</h4>

            <div class="info" style="font-size: 16px;">Please fill out all the sections below to ensure your agreements are made accurately.</div>

           
            <PersonalInfoComponent style="margin: 16px -.75rem;" ref="profile" @saveProfile="saveProfile" @ready="componentReady"></PersonalInfoComponent>



        </div>

        <GetStartedModal v-show="showGetStartedModal" @close-modal="showGetStartedModal = false" />

    </div>

</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import PersonalInfoComponent from '../components/PersonalInfoComponent';
    import GetStartedModal from '../components/modals/GetStartedModal.vue';
    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';


    const business = ref({});
    const showGetStartedModal = ref(false);

    function readProfile() {
        window.$http.request('get', '/api/app/business/read').then((res) => {
            if (res?.Type == 200) {
                business.value = res.data;
                if (business.value.userId == 0) {
                    showGetStartedModal.value = true;
                }
            }
        });
    }

    function saveProfile() {
        window.$http.request('post', '/api/app/business/update', business.value).then((res) => {
            if (res?.Type == 200) {
                window.$message.success('Profile Saved');
               
            }
        });
    }

    onMounted(() => {
        setTimeout(() => { 
            readProfile();
        }, 50);
    });

   

</script>

<style scoped>
   #app {height: 100vh;}
     
    .nav-link {
        color: white;
        width: 100%;
    }
    .nav-link.active{
       
    }
    .container{ background-color:white !important; height:100vh;}
    .info{
        font-size: 12px; color:gray; margin-left:10px;
    }
</style>

